export default {
  nav: {
    home: 'Главная',
    about: 'О нас',
    menu: 'Меню',
    gallery: 'Галерея',
    hours: 'Часы работы',
    contact: 'Контакты',
    order: 'Заказать',
    book: 'Забронировать стол',
    cart: 'Ваш заказ',
  },
  hero: {
    badge: 'Открыто 24 часа каждый день',
    title1: 'Почувствуйте дух',
    highlight: 'Индии',
    title2: 'в любое время',
    subtitle:
      'Аутентичная индийская кухня — от чата до тандура, подаваемая днём и ночью. Наслаждайтесь в тёплом зале на крыше или закажите доставку к двери — когда захотите.',
    explore: 'Смотреть меню',
    delivery: 'Заказать доставку',
    stat1v: '24/7',
    stat1l: 'Всегда открыто',
    stat2v: '174+',
    stat2l: 'Блюд',
    stat3v: '60 мин',
    stat3l: 'Доставка',
  },
  about: {
    eyebrow: 'О Мехфиле',
    title: 'Праздник 24/7 в сердце Еревана',
    p1: 'Созданный компанией Arman International LLC, Mehfil 24/7 приносит дух индийского гостеприимства на улицу Рубенянц. «Мехфиль» означает тёплое собрание — именно это мы и подаём: щедрые блюда, тандурные кебабы, чат, полный вкуса, и террасу на крыше, наполненную светом.',
    p2: 'Будь то ночной панир тикка, утренний масала чай или семейное застолье, длящееся до ночи — наша кухня никогда не спит. Каждое блюдо готовится из аутентичных специй и подаётся с домашним теплом.',
    f1: 'Аутентичная тандурная кухня',
    f2: 'Настоящие индийские специи',
    f3: 'Быстрая доставка 24/7',
    f4: 'Тёплая терраса на крыше',
    cta: 'Посетите нас сегодня',
    badgeV: 'Индер',
    badgeL: 'Владелец и Основатель',
    owner: 'Познакомьтесь с Индером — сердцем и душой Mehfil 24/7. Приехав из Индии, он привнёс свою страсть к аутентичным индийским вкусам в Ереван, создав тёплое пространство, где каждый гость чувствует себя как дома. Его непосредственный подход гарантирует, что каждое блюдо несёт в себе настоящее тепло индийского гостеприимства.',
  },
  menu: {
    eyebrow: 'Наше меню',
    title: '174 блюд на каждый час',
    subtitle:
      'От уличного чата и дымных тандурных стартеров до сливочного ласси и индо-китайских хитов — изучите все блюда, ради которых гости возвращаются снова.',
    all: 'Все',
    add: 'В заказ',
    added: 'Добавлено',
    order: 'Отправить заказ',
    request: 'Просмотреть заказ',
    cats: {
      tea: 'Чай и Кофе',
      shakes: 'Ласси, Шейки и Соки',
      snacks: 'Закуски',
      chaat: 'Чат и Индийские блюда',
      starters: 'Чакхна и Стартеры',
      chinese: 'Китайская кухня',
      raita: 'Райта',
      pizza: 'Пицца / Паста',
      sweets: 'Сладости',
      mainVeg: 'Гл. курс (овощ.)',
      nonVeg: 'Невегетарианское',
      rice: 'Рис',
      breads: 'Хлебные',
      combo: 'Комбо / Юж. Индия',
    },
    items: {
      'ginger-tea': {
        name: 'Имбирный Чай',
        desc: 'Тёплый пряный чай, заваренный со свежим имбирём, кардамоном и корицей — классический индийский напиток.',
        tag: '',
      },
      'masala-tea': {
        name: 'Масала Чай',
        desc: 'Ароматный чёрный чай, томлёный с кардамоном, гвоздикой, корицей, имбирём и молоком — вкус Индии.',
        tag: 'Популярное',
      },
      'plain-tea': {
        name: 'Простой Чай',
        desc: 'Классический индийский чёрный чай, заваренный до совершенства — лёгкий и освежающий.',
        tag: '',
      },
      'elaichi-tea': {
        name: 'Елайчи Чай',
        desc: 'Нежный чёрный чай с ароматными зелёными стручками кардамона — натурально сладкий и благоухающий.',
        tag: '',
      },
      'lemon-tea': {
        name: 'Лимонный Чай',
        desc: 'Освежающий чёрный чай с яркой свежей лимонной нотой — кислый, успокаивающий и бодрящий.',
        tag: '',
      },
      'black-tea': {
        name: 'Чёрный Чай',
        desc: 'Крепкий и насыщенный индийский чёрный чай, заваренный до глубокого медного цвета — смелый и бодрящий.',
        tag: '',
      },
      'green-tea': {
        name: 'Зелёный Чай',
        desc: 'Лёгкий и душистый зелёный чай с чистой травяной нотой и лёгкой сладостью — идеален в любое время.',
        tag: '',
      },
      'black-coffee': {
        name: 'Чёрный Кофе',
        desc: 'Насыщенный южно-индийский фильтр-кофе — тёмный, смелый и полнотелый с гладким послевкусием.',
        tag: '',
      },
      'milk-coffee': {
        name: 'Кофе с Молоком',
        desc: 'Мягкий и кремовый кофе в индийском стиле с молоком, лёгкий подслащённый и идеально сбалансированный.',
        tag: '',
      },
      'cold-coffee': {
        name: 'Холодный Кофе',
        desc: 'Ледяной кофе, взбитый с молоком и лёгкой сладостью — кремовый, освежающий и бодрящий.',
        tag: '',
      },
      'sweet-lassi': {
        name: 'Сладкий Ласси',
        desc: 'Густой и кремовый подслащённый йогуртовый напиток, взбитый до гладкости с ноткой розы — панджаби-классика.',
        tag: 'Популярное',
      },
      'dry-fruit-lassi': {
        name: 'Ласси с Сухофруктами',
        desc: 'Насыщенный ласси с миндалём, фисташками, кешью и шафраном — роскошное, ореховое лакомство.',
        tag: '',
      },
      'salt-lassi': {
        name: 'Солёный Ласси',
        desc: 'Пряный йогуртовый напиток с жареным тмином и щепоткой соли — охлаждающий и идеально кислый.',
        tag: '',
      },
      'pudina-lassi': {
        name: 'Ласси с Мятой',
        desc: 'Освежающий йогуртовый напиток, взбитый со свежими листьями мяты — прохладный, ароматный и бодрящий.',
        tag: '',
      },
      'banana-milkshake': {
        name: 'Банановый Милкшейк',
        desc: 'Кремовый банановый милкшейк, взбитый до гладкости с молоком и лёгкой ноткой ванили — густой и натурально сладкий.',
        tag: '',
      },
      'oreo-shake': {
        name: 'Орео Шейк',
        desc: 'Изысканный милкшейк, насыщенный крошками печенья Орео, сливочным ванильным мороженым и шоколадной стружкой.',
        tag: '',
      },
      'chocolate-milkshake': {
        name: 'Шоколадный Милкшейк',
        desc: 'Насыщенный шоколадный милкшейк с настоящим какао, бархатисто-гладкий, посыпанный шоколадной стружкой.',
        tag: '',
      },
      'strawberry-milkshake': {
        name: 'Клубничный Милкшейк',
        desc: 'Сладкий клубничный милкшейк из свежих ягод — кремовый, натурально розовый и освежающий.',
        tag: '',
      },
      'vanilla-milkshake': {
        name: 'Ванильный Милкшейк',
        desc: 'Классический ванильный милкшейк — густой, кремовый и гладкий — любимец всех возрастов.',
        tag: '',
      },
      'mango-milkshake': {
        name: 'Манговый Милкшейк',
        desc: 'Тропический манговый милкшейк с мякотью спелого манго Альфонсо — насыщенный, золотой и неотразимо сладкий.',
        tag: 'Популярное',
      },
      'dry-fruit-milkshake': {
        name: 'Милкшейк с Сухофруктами',
        desc: 'Ореховый милкшейк, взбитый с миндалём, кешью и финиками — здоровое, богатое белком лакомство.',
        tag: '',
      },
      'watermelon-juice': {
        name: 'Арбузный Сок',
        desc: 'Свежевыжатый арбузный сок — прохладный и натурально сладкий — чистое лето в стакане.',
        tag: '',
      },
      'orange-juice': {
        name: 'Апельсиновый Сок',
        desc: 'Солнечный свет в стакане — свежевыжатый апельсиновый сок, яркий, кислый и богатый витамином C.',
        tag: '',
      },
      'fresh-lime': {
        name: 'Фрэш Лайм',
        desc: 'Пикантный свежий лайм, сладкий и кислый с игристой шипучестью — идеальный утолитель жажды.',
        tag: '',
      },
      'blue-ocean-mojito': {
        name: 'Голубой Океан Мохито',
        desc: 'Потрясающий голубой мохито с мятой, лаймом и каплей тропического блю курасао — яркий и освежающий.',
        tag: '',
      },
      'virgin-mojito': {
        name: 'Вирджин Мохито',
        desc: 'Классический безалкогольный мохито со свежей мятой, лаймом и содой — прохладный, мятный и бодрящий.',
        tag: '',
      },
      'lemon-mint': {
        name: 'Лимон с Мятой',
        desc: 'Прохладный лимонный напиток с листьями свежей мяты — кислый, ароматный и невероятно освежающий.',
        tag: '',
      },
      'veg-samosa': {
        name: 'Вег Самоса',
        desc: 'Хрустящая золотистая выпечка, начинённая пряным картофелем и горохом, подаётся с кислым тамариндовым чатни.',
        tag: '',
      },
      'paneer-samosa': {
        name: 'Панир Самоса',
        desc: 'Слоистая самоса, начинённая сливочным паниром, зеленью и зелёным перцем — насыщенная и сытная.',
        tag: '',
      },
      'veg-sandwich': {
        name: 'Вег Сэндвич',
        desc: 'Гриль-сэндвич с овощами, огурцом, помидором, луком и мятным чатни — свежий и лёгкий.',
        tag: '',
      },
      'grilled-cheese-sandwich': {
        name: 'Сэндвич с Сыром на Гриле',
        desc: 'Масляный гриль-сэндвич, щедро начинённый расплавленным сыром — золотистый и тянущийся с каждым укусом.',
        tag: '',
      },
      'omelette-sandwich': {
        name: 'Сэндвич с Омлетом',
        desc: 'Пышный омлет между ломтиками поджаренного хлеба со свежими овощами и лёгкой ноткой специй.',
        tag: '',
      },
      'chicken-tikka-sandwich': {
        name: 'Сэндвич с Курицей Тикка',
        desc: 'Курица тикка из тандыра в поджаренной булочке с мятным майо и хрустящим луком — дымный и смелый.',
        tag: '',
      },
      'vada-pav': {
        name: 'Вада Пав',
        desc: 'Картофельная котлета в мумбайском стиле в мягкой булочке с чесночным чатни и жареным зелёным перцем.',
        tag: 'Уличная еда',
      },
      'pav-bhaji': {
        name: 'Пав Бхаджи',
        desc: 'Знаменитое мумбайское масляное овощное рагу с поджаренными булочками пав и кусочком масла.',
        tag: 'Бестселлер',
      },
      'mirchi-vada': {
        name: 'Мирчи Вада',
        desc: 'Целый зелёный перец, начинённый пряным картофелем, в кляре и обжаренный до золотистой хрустящей корочки.',
        tag: 'Острое',
      },
      'mix-veg-pakora': {
        name: 'Микс Ведж Пакора',
        desc: 'Ассорти овощных фриттеров — лук, картофель, цветная капуста и шпинат — в кляре и во фритюре.',
        tag: '',
      },
      'paneer-pakora': {
        name: 'Панир Пакора',
        desc: 'Кубики свежего панира в пряном кляре из нутовой муки, обжаренные до хрустящей корочки, подаются с чатни.',
        tag: '',
      },
      'bread-pakora': {
        name: 'Брэд Пакора',
        desc: 'Ломтики хлеба в пряном кляре, обжаренные во фритюре, начинённые картофелем — фаворит к чаю.',
        tag: '',
      },
      'egg-pakora': {
        name: 'Эгг Пакора',
        desc: 'Варёное яйцо, завёрнутое в пряный кляр и обжаренное до золотистой хрустящей корочки — просто и сытно.',
        tag: '',
      },
      'bread-egg-omelette': {
        name: 'Омлет с Хлебом',
        desc: 'Пышный яичный омлет между ломтиками поджаренного хлеба — сытная и насыщенная закуска.',
        tag: '',
      },
      'omelette-2egg': {
        name: 'Омлет [2 яйца]',
        desc: 'Классический омлет из двух яиц с луком, зелёным перцем и кориандром — подаётся горячим и пышным.',
        tag: '',
      },
      'dahi-bhalla': {
        name: 'Дахи Бхалла',
        desc: 'Мягкие чечевичные шарики, пропитанные сладким йогуртом, с кислым тамариндовым и зелёным чатни сверху.',
        tag: '',
      },
      'bhalla-papdi-chaat': {
        name: 'Бхалла Папди Чат',
        desc: 'Щедрый чат с бхалла, хрустящей папди, йогуртом, чатни и нутом — сладкий, кислый и острый.',
        tag: '',
      },
      'dahi-puri': {
        name: 'Дахи Пури',
        desc: 'Хрустящие полые пури, начинённые картофелем, нутом, сладким йогуртом и чатни — взрыв вкуса.',
        tag: '',
      },
      'pani-puri': {
        name: 'Пани Пури',
        desc: 'Король чата — хрустящие пури с острой кислой водой, картофелем и нутом.',
        tag: 'Популярное',
      },
      'papdi-chaat': {
        name: 'Папди Чат',
        desc: 'Хрустящие муки-крекеры с варёным картофелем, нутом, йогуртом и тамариндовым чатни.',
        tag: '',
      },
      'aloo-tikki-chaat': {
        name: 'Алу Тикки Чат',
        desc: 'Золотистые картофельные котлетки с нутом, йогуртом, чатни и хрустящим севом — хрустящие и кремовые.',
        tag: '',
      },
      'tikki-chana-chaat': {
        name: 'Тикки Чана Чат',
        desc: 'Хрустящая алу тикки с пряным нутовым карри и чатни — сытный и насыщенный чат.',
        tag: '',
      },
      'samosa-chana-chaat': {
        name: 'Самоса Чана Чат',
        desc: 'Хрустящая самоса, разломанная в пряное нутовое карри с йогуртом и чатни — шедевр чата.',
        tag: '',
      },
      'aloo-paratha': {
        name: 'Алу Паратха',
        desc: 'Цельнозерновая паратха, начинённая пряным картофельным пюре, подаётся с маслом и йогуртом.',
        tag: '',
      },
      'paneer-paratha': {
        name: 'Панир Паратха',
        desc: 'Слоистая паратха, начинённая крошкой панира, зелёным перцем и кориандром — насыщенная и сытная.',
        tag: '',
      },
      'mix-paratha': {
        name: 'Микс Паратха',
        desc: 'Начинённая паратха с миксом пряных овощей — сытная, полезная и полная вкуса.',
        tag: '',
      },
      'poori-bhaji': {
        name: 'Пури Бхаджи',
        desc: 'Пышные глубоко обжаренные пури с пряным картофельным карри — любимая индийская классика для завтрака.',
        tag: '',
      },
      'chhole-bhature': {
        name: 'Чхоле Бхатура',
        desc: 'Знаменитые пенджабские пышные бхатуры с острым нутовым карри — насыщенные, сытные и незабываемые.',
        tag: 'Пенджабская классика',
      },
      'lemon-chicken-pakora': {
        name: 'Лимонная Курица Пакора',
        desc: 'Хрустящие куриные фриттеры с яркой лимонной нотой, подаются с мятным чатни.',
        tag: '',
      },
      'chicken-pakora': {
        name: 'Курица Пакора',
        desc: 'Нежные кусочки курицы в пряном кляре и обжаренные до хрустящей корочки — сочные внутри, хрустящие снаружи.',
        tag: '',
      },
      'paneer-tikka': {
        name: 'Панир Тикка',
        desc: 'Маринованные кубики панира на гриле в тандыре с перцем и луком — дымные и кремовые.',
        tag: 'Выбор шефа',
      },
      'brunt-chilli-paneer': {
        name: 'Брант Чилли Панир',
        desc: 'Огненный панир, обжаренный с зелёным перцем, луком и соевым соусом — индо-китайская классика.',
        tag: '',
      },
      'brunt-chilli-chicken': {
        name: 'Брант Чилли Курица',
        desc: 'Острые кусочки курицы, обжаренные с обугленным перцем, чесноком и соей — смелые, дымные и притягательные.',
        tag: '',
      },
      'paneer-65': {
        name: 'Панир 65',
        desc: 'Глубоко обжаренные кубики панира в остром, кислом соусе 65 с каджипатта и перцем.',
        tag: '',
      },
      'chicken-65': {
        name: 'Курица 65',
        desc: 'Легендарный южно-индийский стартер — хрустящая курица в огненном красном соусе 65 с каджипатта.',
        tag: 'Популярное',
      },
      'chilli-mushroom': {
        name: 'Чилли Грибы',
        desc: 'Хрустящие жареные грибы в остром чилли-соусе с перцем и луком — кислые и острые.',
        tag: '',
      },
      'plain-papad': {
        name: 'Плейн Папад',
        desc: 'Хрустящие обжаренные чечевичные вафли, лёгкие и пряные — идеальная хрустящая закуска к любому блюду.',
        tag: '',
      },
      'masala-papad': {
        name: 'Масала Папад',
        desc: 'Хрустящий папад с нарезанным луком, помидорами, зелёным перцем и кориандром сверху — свежий и пикантный.',
        tag: '',
      },
      'peanut-masala': {
        name: 'Пинат Масала',
        desc: 'Жареный арахис с луком, помидорами, лимонным соком и специями — хрустящая, кислая бар-закуска.',
        tag: '',
      },
      'fried-masala-chana': {
        name: 'Фрайд Масала Чана',
        desc: 'Хрустящие жареные нуты, приправленные чат масала и специями — завораживающие и хрустящие.',
        tag: '',
      },
      'cucumber-salad': {
        name: 'Салат с Огурцом',
        desc: 'Прохладные и хрустящие ломтики огурца с лимоном, чат масала и свежим кориандром — освежающий.',
        tag: '',
      },
      'mix-green-salad': {
        name: 'Микс Грин Салад',
        desc: 'Яркий микс салатных листьев, огурца, помидора и лука с лёгким лимонным соусом — лёгкий и свежий.',
        tag: '',
      },
      'onion-salad': {
        name: 'Луковый Салат',
        desc: 'Тонко нарезанные кольца лука с зелёным перцем, лимоном и чат масала — острый и кислый.',
        tag: '',
      },
      'fruit-chaat': {
        name: 'Фрут Чат',
        desc: 'Свежие сезонные фрукты с чат масала, чёрной солью и лимонным соком — сладкий, кислый и острый.',
        tag: '',
      },
      'french-fries': {
        name: 'Французский Фри',
        desc: 'Золотые, хрустящие картофель фри, идеально посоленные и поданные горячими — вневременная классика.',
        tag: '',
      },
      'chilli-potato': {
        name: 'Чилли Картофель',
        desc: 'Хрустящие картофельные дольки в остром чилли-соусе с перцем и луком — горячие и хрустящие.',
        tag: '',
      },
      'honey-chilli-fries': {
        name: 'Хани Чилли Фри',
        desc: 'Хрустящий фри, глазированный сладким мёдом и острым чилли-соусом с кунжутом — где сладкое встречает острое.',
        tag: '',
      },
      'honey-chilli-cauliflower': {
        name: 'Хани Чилли Цветная Капуста',
        desc: 'Хрустящие соцветия цветной капусты в липком мёд-чилли глазури — хрустящие, сладкие и огненные.',
        tag: '',
      },
      'aloo-tikki-burger': {
        name: 'Алу Тикки Бургер',
        desc: 'Хрустящая картофельная котлета в мягкой булочке с майо и свежими овощами — дези-твист на классику.',
        tag: '',
      },
      'cheese-burger': {
        name: 'Чизбургер',
        desc: 'Сочная котлета с расплавленным сыром, свежим салатом и помидором в поджаренной булочке — вневременный комфорт-фуд.',
        tag: '',
      },
      'paneer-burger': {
        name: 'Панир Бургер',
        desc: 'Гриль-панир в мягкой булочке с острым майо и хрустящими овощами — фаворит вегетарианцев.',
        tag: '',
      },
      'chicken-burger': {
        name: 'Чикен Бургер',
        desc: 'Гриль-котлета из курицы со свежим салатом, помидором и майо в поджаренной булочке — сочная и сытная.',
        tag: '',
      },
      'desi-fried-burger': {
        name: 'Дези Фрайд Бургер',
        desc: 'Хрустящая жареная котлета, насыщенная индийскими специями, с луком и чатни в дези-булочке.',
        tag: '',
      },
      'veg-maggi': {
        name: 'Ведж Магги',
        desc: 'Классическая лапша Магги, обжаренная со свежими овощами и дези-специями — быстрая, острая и ностальгическая.',
        tag: '',
      },
      'egg-maggi': {
        name: 'Эгг Магги',
        desc: 'Лапша Магги с яичницей и овощами — белковая версия любимого блюда из детства.',
        tag: '',
      },
      'masala-maggi': {
        name: 'Масала Магги',
        desc: 'Лапша Магги, загруженная дополнительной масалой, луком, помидором и зелёным перцем — смелая и дези.',
        tag: '',
      },
      'momos': {
        name: 'Момос',
        desc: 'Паровые пельмени, начинённые приправленными овощами или курицей, подаются с острым красным чатни.',
        tag: 'Популярное',
      },
      'veg-manchurian': {
        name: 'Ведж Манчуриан',
        desc: 'Хрустящие овощные шарики в кисло-остром манчурианском соусе с чесноком и зелёным луком.',
        tag: '',
      },
      'chicken-manchurian': {
        name: 'Чикен Манчуриан',
        desc: 'Жареная курица в насыщенном, остром манчурианском соусе с перцем и луком — дези-китайская классика.',
        tag: '',
      },
      'hakka-noodles': {
        name: 'Хакка Нудлс',
        desc: 'Лапша стир-фрай с хрустящими овощами, соевым соусом и дези-специями — идеальное обжаривание в воке.',
        tag: '',
      },
      'chicken-noodles': {
        name: 'Чикен Нудлс',
        desc: 'Лапша в воке с нежными полосками курицы, овощами и дымным соево-чилли глазурью.',
        tag: '',
      },
      'indian-chowmin': {
        name: 'Индиан Чаумин',
        desc: 'Дези-стиль чаумен с овощами, яйцом и острыми соусами — уличная лапша в лучшем виде.',
        tag: '',
      },
      'veg-spring-rolls': {
        name: 'Ведж Спринг Роллс',
        desc: 'Золотые хрустящие роллы, начинённые приправленными овощами, подаются с кисло-сладким соусом для макания.',
        tag: '',
      },
      'tomato-soup': {
        name: 'Томатный Суп',
        desc: 'Кремовый томатный суп с лёгкой ноткой индийских специй, подаётся горячим с хрустящими крутонами сверху.',
        tag: '',
      },
      'chicken-manchow-soup': {
        name: 'Чикен Манчау Суп',
        desc: 'Сытный индо-китайский суп с рубленой курицей, хрустящей лапшой и смелым, острым бульоном.',
        tag: '',
      },
      'manchow-soup': {
        name: 'Манчау Суп',
        desc: 'Острый овощной манчау-суп с хрустящей жареной лапшой сверху — смелый, согревающий и полный вкуса.',
        tag: '',
      },
      'hot-n-sour-soup': {
        name: 'Хот энд Соу Суп',
        desc: 'Огненный, кислый суп с овощами, тофу и ударом чёрного перца и уксуса — интенсивный и сытный.',
        tag: '',
      },
      'plain-curd': {
        name: 'Плейн Курд',
        desc: 'Свежий домашний йогурт — прохладный и кремовый — идеальное очищение вкуса к любому острому блюду.',
        tag: '',
      },
      'plain-raita': { name: 'Плейн Райта', desc: 'Прохладный йогурт с кумином и кориандром.', tag: '' },
      'boondi-raita': { name: 'Бунди Райта', desc: 'Хрустящие шарики бунди в холодном йогурте.', tag: '' },
      'mix-raita': { name: 'Микс Райта', desc: 'Йогурт с огурцом, помидором, луком и бунди.', tag: '' },
      'margarita-pizza': { name: 'Маргарита Пицца', desc: 'Классическая пицца с томатным соусом и моцареллой.', tag: '' },
      'chef-veggie-pizza': { name: 'Пицца Шеф Специал', desc: 'Загружена перцем, грибами, кукурузой, оливками и тремя видами сыра.', tag: '' },
      'paneer-tikka-pizza': { name: 'Панир Тикка Пицца', desc: 'Тандурный панир, лук и перец на сырной основе.', tag: '' },
      'chicken-tikka-pizza': { name: 'Курица Тикка Пицца', desc: 'Дымная курица тикка с луком и чатни.', tag: '' },
      'onion-pizza': { name: 'Пицца с Луком', desc: 'Карамелизованный лук с моцареллой на тонком корже.', tag: '' },
      'boondi-laddu': { name: 'Бунди Ладду', desc: 'Золотые шарики из нутовой муки в сахарном сиропе.', tag: '' },
      'khowa-barfi': { name: 'Хова Барфи', desc: 'Насыщенная молочная барфи с ароматом кардамона.', tag: '' },
      'kaju-katli': { name: 'Каджу Катли', desc: 'Кешью-помадка в форме ромбов с серебряным листом.', tag: '' },
      'besan-barfi': { name: 'Бесан Барфи', desc: 'Барфи из нутовой муки, жаренной в гхи.', tag: '' },
      'guliya': { name: 'Гулия', desc: 'Слоёные пирожки с кокосом и орехами.', tag: '' },
      'motichur-laddu': { name: 'Мотичур Ладду', desc: 'Маленькие золотые шарики бунди в сахарном сиропе.', tag: '' },
      'milk-cake': { name: 'Молочный Торт', desc: 'Загущённое молоко, сваренное до карамелизации.', tag: '' },
      'jalebi': { name: 'Джалеби', desc: 'Хрустящие спирали в шафрановом сахарном сиропе.', tag: '' },
      'gulab-jamun': { name: 'Гулаб Джамун', desc: 'Мягкие шарики из молочных сухих веществ в розовом сиропе.', tag: '' },
      'rasgula': { name: 'Расгула', desc: 'Мягкие губчатые шарики из творога в сахарном сиропе.', tag: '' },
      'boondi-sweet': { name: 'Бунди', desc: 'Маленькие золотые капли из нутовой муки, сладкие и хрустящие.', tag: '' },
      'peda': { name: 'Педа', desc: 'Молочные диски с кардамоном и шафраном.', tag: '' },
      'rasmalai': { name: 'Расмалай', desc: 'Паниp в молоке с шафраном, украшенный фисташками.', tag: '' },
      'daal-tadka': { name: 'Дал Тадка', desc: 'Жёлтая чечевица с тмином, чесноком и перцем в гхи.', tag: '' },
      'aloo-matter': { name: 'Алу Матер', desc: 'Картофель и горох в томатно-луковом соусе.', tag: '' },
      'aloo-chhole': { name: 'Алу Чхоле', desc: 'Нут с картофелем в пряном карри.', tag: '' },
      'zeera-aloo': { name: 'Зира Алу', desc: 'Картофель с семенами тмина и куркумой.', tag: '' },
      'mix-veg-kolapuri': { name: 'Микс Вег Колапури', desc: 'Овощи в огненном соусе Колхапури с кокосом.', tag: '' },
      'matter-paneer': { name: 'Матер Панир', desc: 'Панир и горошек в сливочном соусе.', tag: '' },
      'kadhai-paneer': { name: 'Кадхай Панир', desc: 'Панир с перцем в густом пряном соусе.', tag: '' },
      'shahi-paneer': { name: 'Шахи Панир', desc: 'Королевский панир в сливочном соусе с кешью.', tag: '' },
      'paneer-lawabdar': { name: 'Панир Лавабдар', desc: 'Панир в сочном кислом соусе с пажитником.', tag: '' },
      'adarki-daniya-paneer': { name: 'Адарки Дания Панир', desc: 'Панир в имбирно-кориандровом соусе.', tag: '' },
      'mushroom-payaja': { name: 'Грибы Пайяджа', desc: 'Грибы с карамелизованным луком в сливочном соусе.', tag: '' },
      'sev-bhaji': { name: 'Сев Бхаджи', desc: 'Хрустящий сев в томатно-луковом соусе с арахисом.', tag: '' },
      'paneer-butter-masala': { name: 'Панир Батер Масала', desc: 'Панир в томатно-масляно-сливочном соусе.', tag: '' },
      'makhni-paneer': { name: 'Махни Панир', desc: 'Панир в шёлковом соусе махани.', tag: '' },
      'daal-makhni': { name: 'Дал Махни', desc: 'Чёрная чечевица медленного приготовления с маслом и сливками.', tag: '' },
      'chicken-rara-masala': { name: 'Курица Рара Масала', desc: 'Фарш и кусочки курицы в густом пряном соусе.', tag: '' },
      'kadhai-chicken': { name: 'Кадхай Курица', desc: 'Курица с перцем в густом пряном соусе.', tag: '' },
      'butter-chicken': { name: 'Курица Батер', desc: 'Тандурная курица в шёлковом томатно-масляном соусе.', tag: '' },
      'lemon-chicken-gravy': { name: 'Лимонная Курица', desc: 'Курица в остро-кислом лимонном соусе.', tag: '' },
      'chicken-curry': { name: 'Курица Карри', desc: 'Классическое домашнее карри из курицы.', tag: '' },
      'egg-curry': { name: 'Яйцо Карри', desc: 'Варёные яйца в томатно-луковом соусе.', tag: '' },
      'egg-bhurji': { name: 'Яичница Бхурджи [2 яйца]', desc: 'Яичница с луком, томатами и специями.', tag: '' },
      'steamed-rice': { name: 'Варёный Рис', desc: 'Пышный рис басмати.', tag: '' },
      'pea-pulao': { name: 'Горошек Пулао', desc: 'Басмати с горохом и специями.', tag: '' },
      'zeera-rice': { name: 'Зира Рис', desc: 'Басмати с семенами тмина и гхи.', tag: '' },
      'veg-fried-rice': { name: 'Жареный Рис с Овощами', desc: 'Рис с овощами в воке.', tag: '' },
      'egg-fried-rice': { name: 'Жареный Рис с Яйцом', desc: 'Рис с яичницей и овощами.', tag: '' },
      'chicken-fried-rice': { name: 'Жареный Рис с Курицей', desc: 'Рис с куриными полосками.', tag: '' },
      'veg-biryani': { name: 'Вег Бирьяни', desc: 'Ароматный рис с овощами и шафраном.', tag: '' },
      'chicken-biryani': { name: 'Куриный Бирьяни', desc: 'Маринованная курица с ароматным рисом.', tag: '' },
      'egg-biryani': { name: 'Яичный Бирьяни', desc: 'Рис с варёными яйцами и специями.', tag: '' },
      'tawa-roti': { name: 'Тава Роти', desc: 'Цельнозерновой хлеб на горячей сковороде.', tag: '' },
      'tawa-butter-roti': { name: 'Тава Роти с Маслом', desc: 'Роти, смазанный сливочным маслом.', tag: '' },
      'simple-paratha': { name: 'Простая Паратха', desc: 'Слоистая цельнозерновая паратха.', tag: '' },
      'tandoori-roti': { name: 'Тандури Роти', desc: 'Хлеб из тандыра — дымный и ароматный.', tag: '' },
      'tandoori-butter-roti': { name: 'Тандури Роти с Маслом', desc: 'Тандури роти со сливочным маслом.', tag: '' },
      'plain-naan': { name: 'Плейн Наан', desc: 'Мягкий квашеный хлеб из тандыра.', tag: '' },
      'butter-naan': { name: 'Наан с Маслом', desc: 'Наан со сливочным маслом.', tag: '' },
      'garlic-naan': { name: 'Чесночный Наан', desc: 'Маслянистый наан с чесноком и кориандром.', tag: '' },
      'messi-roti': { name: 'Месси Роти', desc: 'Многослойный слоистый роти.', tag: '' },
      'lacha-paratha': { name: 'Лача Паратха', desc: 'Паратха со спиральными слоями.', tag: '' },
      'onion-kulcha': { name: 'Луковая Кулча', desc: 'Хлеб с пряным луком и кориандром.', tag: '' },
      'aloo-kulcha': { name: 'Картофельная Кулча', desc: 'Хлеб, начинённый пряным картофелем.', tag: '' },
      'paneer-kulcha': { name: 'Панир Кулча', desc: 'Мягкая кулча с панир.', tag: '' },
      'mix-kulcha': { name: 'Микс Кулча', desc: 'Начинённая кулча с паниром, луком и картофелем.', tag: '' },
      'daal-rice-combo': { name: 'Дал / Рис', desc: 'Чечевичное карри с рисом.', tag: '' },
      'rajma-rice-combo': { name: 'Раджма / Рис', desc: 'Карри из красной фасоли с рисом.', tag: '' },
      'chhole-rice-combo': { name: 'Чхоле / Рис', desc: 'Нутовое карри с рисом.', tag: '' },
      'kaddi-rice-combo': { name: 'Кадди / Рис [Воскресенье]', desc: 'Йогуртовое карри с рисом.', tag: '' },
      'daal-churma-combo': { name: 'Дал / Чурма [Мехфил]', desc: 'Раджастанский праздник.', tag: '' },
      'uttapam-combo': { name: 'Уттапам / Самбар / Чатни', desc: 'Южноиндийский рисовый блин.', tag: '' },
      'dosa-combo': { name: 'Доса / Самбар / Чатни', desc: 'Хрустящий рисовый блин с самбаром.', tag: '' },
      'masala-dosa-combo': { name: 'Масала Доса / Самбар / Чатни', desc: 'Доса с начинкой из картофеля.', tag: '' },
      'vegy-burger-combo': { name: 'Вег Бургер / Картофель / Кола', desc: 'Быстрый комплексный обед.', tag: '' },
      'veg-paratha-fries-combo': { name: 'Вег Паратха + Картофель', desc: 'Паратха с картофелем фри.', tag: '' },
      'paratha-roll-combo': { name: 'Панир / Курица Паратха Ролл', desc: 'Рулет из паратхи с начинкой.', tag: '' },
      'veg-sandwich-club': { name: 'Вег Сэндвич Клаб [Мехфил]', desc: 'Трёхэтажный вегетарианский клаб.', tag: '' },
      'chicken-sandwich-club': { name: 'Курица Сэндвич Клаб [Мехфил]', desc: 'Трёхэтажный куриный клаб.', tag: '' },
    },
  },
  gallery: {
    eyebrow: 'Галерея',
    title: 'Моменты за столом',
    subtitle: 'Загляните в наши тёплые интерьеры, кухню с тандыром и яркий чат-стол.',
    t: {
      g1: 'Тёплый уютный интерьер',
      g2: 'Кухня с открытым тандыром',
      g3: 'Яркий чат-стол',
      g4: 'Свежие специи и зелень',
    },
  },
  hours: {
    eyebrow: 'Часы работы',
    title: 'Наши двери никогда не закрываются',
    subtitle:
      'Днём и ночью Mehfil 24/7 с вами. Хотите завтрак в 3 ночи или поздний ужин в полночь — наша кухня и терраса всегда ждут вас.',
    order: 'Заказать сейчас',
    map: 'Найти нас на карте',
    schedule: 'Расписание на неделю',
    open: 'Открыто сейчас',
    open24: 'Открыто 24 часа',
    days: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
  },
  reviews: {
    eyebrow: 'Отзывы',
    title: 'Любимы нашими гостями',
    t: {
      t1text:
        'Мехфиль — моё место для позднего вечера. Панир тикка здесь лучший в Ереване, а то, что открыто 24/7, — настоящее спасение.',
      t2text:
        'Заказал пав бхаджи в 2 часа ночи, и он приехал горячим и идеально упакованным. Самоса чат на вкус как мумбайский.',
      t3text:
        'Красивая атмосфера, приветливый персонал и невероятный манговый милкшейк. Индо-китайское меню здесь — то, чего нет больше нигде в Ереване.',
    },
  },
  booking: {
    eyebrow: 'Бронирование',
    title: 'Забронировать стол',
    subtitle:
      'Забронируйте место и отправьте запрос прямо в наш WhatsApp — мы сразу подтвердим.',
    name: 'Ваше имя',
    phone: 'Телефон',
    guests: 'Количество гостей',
    date: 'Дата',
    time: 'Время',
    note: 'Особые пожелания (необязательно)',
    send: 'Отправить бронь в WhatsApp',
    sending: 'Открываем WhatsApp…',
  },
  order: {
    eyebrow: 'Навынос и доставка',
    title: 'Создать заказ',
    subtitle:
      'Соберите заказ, добавьте детали и отправьте всё в наш WhatsApp. Мы быстро подтвердим и доставим.',
    name: 'Ваше имя',
    phone: 'Телефон',
    address: 'Адрес доставки',
    note: 'Комментарии к заказу (необязательно)',
    send: 'Отправить заказ в WhatsApp',
    sending: 'Открываем WhatsApp…',
    empty: 'Ваш заказ пуст — добавьте блюда из меню ниже.',
    browse: 'Смотреть меню',
    total: 'Итого',
  },
  cart: {
    title: 'Ваш заказ',
    empty: 'Ваш заказ пуст. Добавьте блюда из меню.',
    browse: 'Смотреть меню',
    name: 'Ваше имя',
    phone: 'Телефон',
    address: 'Адрес доставки',
    note: 'Комментарии (необязательно)',
    total: 'Итого',
    send: 'Отправить заказ в WhatsApp',
    clear: 'Очистить заказ',
    continue: 'Продолжить просмотр',
    items: 'блюд',
  },
  info: {
    visit: 'Посетите нас',
    call: 'Звоните 24/7',
    open: 'Всегда открыто',
    delivery: 'Доставка',
    address: 'ул. Рубенянца 28/1, Ереван 0069, Армения',
    phone1: '+374 93 951149',
    phone2: '+374 93 951149',
    hours: 'Пн – Вс, открыто 24 часа',
    deliv: 'По всему Еревану, ~60 минут',
  },
  footer: {
    desc: 'Аутентичная индийская кухня — от тандыра до чата, подаваемая в любое время суток — от Arman International LLC.',
    links: 'Быстрые ссылки',
    touch: 'Свяжитесь с нами',
    follow: 'Мы в соцсетях',
    about: 'О нас',
    menu: 'Наше меню',
    gallery: 'Галерея',
    contact: 'Контакты',
    rights: 'Все права защищены.',
    tagline: 'Открыто каждый день, круглосуточно.',
    curatedBy: 'Курирует',
  },
};